var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon32Comment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-32-comment",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7233",
    "data-name": "Rectangle 7233",
    width: 32,
    height: 32,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "message",
    d: "M23.543,1H4.709A4.722,4.722,0,0,0,0,5.709V17.48a4.722,4.722,0,0,0,4.709,4.709V25.72a1.178,1.178,0,0,0,2,.824l4.355-4.355H23.543a4.722,4.722,0,0,0,4.709-4.709V5.709A4.722,4.722,0,0,0,23.543,1ZM16.48,15.126H9.417a1.177,1.177,0,1,1,0-2.354H16.48a1.177,1.177,0,0,1,0,2.354Zm2.354-4.709H9.417A1.112,1.112,0,0,1,8.24,9.24,1.112,1.112,0,0,1,9.417,8.063h9.417A1.112,1.112,0,0,1,20.011,9.24,1.112,1.112,0,0,1,18.834,10.417Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon32Comment);
export default __webpack_public_path__ + "static/media/icon-32-comment.7a5f61489e1ba0fc3ba9e73aece66d7d.svg";
export { ForwardRef as ReactComponent };